module.exports = __webpack_public_path__ + "assets/img/tx266s.a39261cd.jpg";